// External imports
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

// Local imports
import { logoutSuccess } from '../actions/user/userActions'

const ProtectedRoute = ({ dispatch, component: Component, login,  ...rest }) => {
    // alert(localStorage.getItem('login'))
    return (<Route {...rest} render={(props) => {
        if(localStorage.getItem('userData')){
            return <Component {...props} />
        }else{
            dispatch(logoutSuccess())
            return <Redirect to={{ pathname: '/', state: { from: props.location }}} />
        }
        //  (localStorage.getItem('userData')) ? <Component {...props} /> : <Redirect to={{ pathname: '/', state: { from: props.location }}} />   
    }} />
    )}

 // Map Redux state to React component props
const mapStateToProps = state => ({
    login: state.users.login
})

// Connect Redux to React
export default connect(mapStateToProps)(ProtectedRoute)